import * as React from "react";
import {BooleanStatusEnum} from "../../filters/BooleanStatusFilter";

interface IProps {
	value?: boolean;
}

export const BooleanStatusPresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{props.value == true ? BooleanStatusEnum.Disabled : props.value == false ? BooleanStatusEnum.Active : "-"}</span>
	);
};